<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B4.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                         <!-- 新闻资讯 -->
                        {{ $t('news.news_banner_title') }}
                    </h1>
                    <h3>
                         <!-- 以客户的成功定义成功，赋能企业管理，来自企业的信赖 -->
                        {{ $t('news.news_banner_subtitle') }}
                    </h3>
                </div>
                <!-- <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: 'news' }">新闻资讯</el-breadcrumb-item>
                        <el-breadcrumb-item>{{ objParam.title }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div> -->
            </div>
        </section>
        <section></section>

        <section class="blog-details">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-xl-12">
                        <div  class="blog-details_centent ">
                            <div class="blog-details_centent__title">
                                <p>
                                    <!-- {{ objParam.title }} -->
                                    {{ $t(`news.${objParam.i18n_title}`) }}
                                </p>
                            </div>
                            <div class="blog-details_centent__conter">
                                    <span class="blog-details_centent__conter_left"><i class="far fa-clock"></i> {{ objParam.time }}</span>
                            </div>
                        </div>
                    </div>
               
                </div>
                <div class="row">
                    <div class="col-lg-12 col-xl-12">
                        <div class="details__centent">
                            <!-- 内容 -->
                            <div>
                                <div class="inside-tex warp wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">                                   
                                        <div v-for="(item, index) in list" :key="index" >
                                            <p  class="details__centent_text" v-if="item.type=='text'" >
                                                 <!-- {{ item.content }} -->
                                                {{ $t(`news.${item.content}`) }}
                                            </p>
                                            <p style="text-align: center;" v-else> 
                                                <img class="details__centent_img"  :src=" item.content " title="QQ截图20230612133917.jpg" alt="QQ截图20230612133917.jpg">
                                            </p>
                                            
                                        </div>
                               
                                </div>
                            </div>
                            <div class="projectc-details__pagination-box">
                               
                                <div class="next pagination_item">
                                    <div class="icon">
                                        <a @click="handlePrevious(objParam.previousId)"  aria-label="Previous"><i class="fa fa-long-arrow-alt-right"></i></a>
                                    </div>
                                    <div class="content">
                                        <!-- <span>上一条</span> -->
                                        <template v-if="objParam.previousTitle && objParam.previousId">
                                        <p class="content__p_text">
                                            <!-- {{ objParam.previousTitle }} -->
                                            <!-- {{ objParam.previousTitle }} -->
                                            {{ $t(`news.${objParam.i18n_previousTitle}`) }}
                                        </p>
                                        </template>
                                        <template v-else>
                                                <p class="content__p_text">
                                                    <!-- 没有了 -->
                                                    {{ $t('news.news_detail_noMore') }}
                                                </p>
                                        </template>
                                    </div>
                                    
                                </div>
                                <div class="previous pagination_item">
                                    <div class="content">
                                        <template v-if="objParam.nextTitle && objParam.nextId">
                                            <p class="content__p_text">
                                                <!-- {{  objParam.nextTitle }} -->
                                                {{ $t(`news.${objParam.i18n_nextTitle}`) }}
                                            </p>
                                        </template>
                                        <template v-else>
                                            <p class="content__p_text">
                                                <!-- 没有了 -->
                                                {{ $t('news.news_detail_noMore') }}
                                            </p>
                                        </template>
                                    </div>
                                    <div class="icon">
                                        <a @click="handleNext(objParam.nextId)"  aria-label="Previous"><i class="fa fa-long-arrow-alt-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Blog Sidebar End-->
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'newsDetail',
    mixins: [MixinsList],
    data () {
        return {
            list: [],
            objParam: {},
        }
    },
    created() {
        this.getData()  // 获取内容
    },
    mounted () {
      
    },
    methods: {
        // 获取数据
        async getData() {
            // var judgeId = this.$route.query.id

            // const { result } = res
            // console.log("新闻详情", result.title)
            // var arr = JSON.parse(JSON.stringify(result.records))  // 新闻信息
            // var param = ""
            // if( judgeId ) {
            //     param = arr.find(item => item.id == judgeId);
            // }
            // this.objParam = param
            // this.list = this.objParam.newsList

            try {
                var judgeId = this.$route.query.id
            
                const  result  = await loadData('newsData', this.lang)
                
                var arr = JSON.parse(JSON.stringify(result.records))  // 新闻信息
                var param = ""
                if( judgeId ) {
                    param = arr.find(item => item.id == judgeId);
                }
                this.objParam = param
                this.list = this.objParam.newsList

            } catch (error) {
                console.log(error)
            }

        },
        // 下一条，
        handlePrevious(value) {
            if(value) {
                this.$router.push({
                    path: "mbNewsDetail",
                    query: {
                        id: value,
                    }
                });
            }
        },
        // 上一条，
        handleNext(value) {
            if(value) {
                this.$router.push({
                path: "mbNewsDetail",
                query: {
                    id: value,
                }
            });
            }
           
        },
    }
}
</script>
<style scoped>
/* banner图片 */
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}
/* 详情内容 */
.blog-details {
    background: var(--notech-extra);
    padding: 60px 0 60px;
}

.blog-details_centent {
    /* margin-bottom: 60px; */
    width: 100%;
    background: #fff;
    /* padding: 30px 160px; */
    padding: 10px;
    text-align: center;
    box-shadow: 2.5px 4.33px 50px 0px rgba(30, 39, 61, 0.04);
}
/* 详情标题 */
.blog-details_centent__title {
    color: var(--notech-black);
    /* font-size: var(--font-size-24); */
    font-size: 18px;
    line-height: 1.75;
    text-align: center;
}  
.blog-details_centent__conter{
    margin-top: 25px;
    line-height: 32px;
    font-size: var(--font-size-16);
    font-weight: 400;
    color: var(--notech-gray) !important;
    transition: all 500ms ease;
}
.blog-details_centent__conter i {
    color: var(--notech-primary);
    font-size: var(--font-size-16);
    padding-right: 2px;
}

/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    /* font-size: var(--font-size-16); */
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}

/* 内容 */
.details__centent {
    margin-top: 10px;
    background: #fff;
    /* padding: 45px 100px; */
    padding: 10px;
    box-shadow: 2.5px 4.33px 50px 0px rgba(30, 39, 61, 0.04);
}
.details__centent_text {
    font-size: 16px;
    white-space: normal;
    text-indent: 32px;
    line-height: 32px;
  }
  .details__centent_img{
    max-width: 100%;
  }

  .projectc-details__pagination-box {
    margin-top: 60px;
  }
/* 标题过长隐藏 */
.content__p_text {
    padding: 0 10px;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .pagination_item {
    border: 1px solid var(--notech-bdr-color);
    display: flex;
    width: 100%;
    padding: 10px 5px;
  }
  .next .icon i {
    position: relative;
    height: 40px;
    width: 40px;
    background-color: var(--notech-extra);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--notech-base);
    font-size: var(--font-size-16);
    transform: rotate(180deg);
    transition: all 500ms ease;
  }
  .previous .icon i{
    position: relative;
    height: 40px;
    width: 40px;
    background-color: var(--notech-extra);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--notech-base);
    font-size: var(--font-size-16);
    /* margin-left: 20px; */
    transition: all 500ms ease;
    z-index: 1;
}
  .icon {
    width: 40px;
  }
  .content {
    width: calc(100% - 40px);
  }
  .previous .content__p_text {
    text-align: right;
  }
  .next .content__p_text {
    text-align: left;
  }
  
</style> 
